import { toastController } from '@ionic/vue';

interface ToastOpts {
  duration?: number;
}

export function useToast() {
  async function successToast(message: string, opts?: ToastOpts) {
    const t = await toastController.create({
      message,
      duration: opts?.duration || 2500,
      cssClass: 'success-toast',
      swipeGesture: 'vertical',
      position: 'top',
      positionAnchor: 'app-header',
    });
    await t.present();
  }

  async function errorToast(message: string, opts?: ToastOpts) {
    const t = await toastController.create({
      message,
      duration: opts?.duration || 2500,
      cssClass: 'error-toast',
      swipeGesture: 'vertical',
      position: 'top',
      positionAnchor: 'app-header',
    });
    await t.present();
  }

  return { successToast, errorToast };
}
